import { DtoBase } from "../../DtoBase";
import { ActiveDirectorySettingsDto, GoogleWorkspaceSettingsDto, SamlSettingsDto } from "UvExplorerServer.Dtos.TS/Auth";


export class GetAuthSettingsResultDto extends DtoBase {

	public ActiveDirectorySettings: ActiveDirectorySettingsDto;
	public GoogleWorkspaceSettings: GoogleWorkspaceSettingsDto;
	public SamlSettings: SamlSettingsDto;

	constructor() {
		super();

		this.ActiveDirectorySettings = null;
		this.GoogleWorkspaceSettings = null;
		this.SamlSettings = null;
	}

	public get HasActiveDirectorySettings(): boolean {
		return !!this.ActiveDirectorySettings;
	}

	public get HasGoogleWorkspaceSettings(): boolean {
		return !!this.GoogleWorkspaceSettings;
	}

	public get HasSamlSettings(): boolean {
		return !!this.SamlSettings;
	}

	public Write(obj: any, context: any): void {
		obj.get_auth_settings_result = {};
		obj = obj.get_auth_settings_result;

		super.Write(obj, context);

		if (this.HasActiveDirectorySettings)
			this.ActiveDirectorySettings.Write(obj, context);

		if (this.HasGoogleWorkspaceSettings)
			this.GoogleWorkspaceSettings.Write(obj, context);

		if (this.HasSamlSettings)
			this.SamlSettings.Write(obj, context);
	}

	public Read(obj: any, context: any): void {

		if (!obj.get_auth_settings_result)
			throw new Error();
		obj = obj.get_auth_settings_result;

		super.Read(obj, context);

		if (obj.active_directory_settings !== undefined) {
			this.ActiveDirectorySettings = new ActiveDirectorySettingsDto();
			this.ActiveDirectorySettings.Read(obj, context);
		}

		if (obj.google_workspace_settings !== undefined) {
			this.GoogleWorkspaceSettings = new GoogleWorkspaceSettingsDto();
			this.GoogleWorkspaceSettings.Read(obj, context);
		}

		if (obj.saml_settings !== undefined) {
			this.SamlSettings = new SamlSettingsDto();
			this.SamlSettings.Read(obj, context);
		}
	}

}